import { createStore } from 'vuex';
import admin from './modules/admin';
import marketing from './modules/marketing';
export default createStore({
  modules: {
    admin,
    marketing
  }
});